// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import AnalyticsAttributionController from "./analytics_attribution_controller"
application.register("analytics-attribution", AnalyticsAttributionController)

import DismissibleController from "./dismissible_controller"
application.register("dismissible", DismissibleController)

import CollapsibleController from "./collapsible_controller"
application.register("collapsible", CollapsibleController)

import ConfirmModalController from "./confirm_modal_controller"
application.register("confirm-modal", ConfirmModalController)

import CurrencyInputController from "./currency_input_controller"
application.register("currency-input", CurrencyInputController)

import CustomSelectController from "./custom_select_controller"
application.register("custom-select", CustomSelectController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InlineFormController from "./inline_form_controller"
application.register("inline-form", InlineFormController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ModalOpenerController from "./modal_opener_controller"
application.register("modal-opener", ModalOpenerController)

import MultiSelectController from "./multi_select_controller"
application.register("multi-select", MultiSelectController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import PricingController from "./pricing_controller"
application.register("pricing", PricingController)

import SearchableSelectController from "./searchable_select_controller"
application.register("searchable-select", SearchableSelectController)

import SegmentedControlController from "./segmented_control_controller"
application.register("segmented-control", SegmentedControlController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import TransactionFormController from "./transaction_form_controller"
application.register("transaction-form", TransactionFormController)

import TrialWarningModalController from "./trial_warning_modal_controller"
application.register("trial-warning-modal", TrialWarningModalController)

import SearchClearController from "./search_clear_controller"
application.register("search-clear", SearchClearController)

import MobileCollapsibleController from "./mobile_collapsible_controller"
application.register("mobile-collapsible", MobileCollapsibleController)

import FilterStateController from "./filter_state_controller"
application.register("filter-state", FilterStateController)

import FilterSearchController from "./filter_search_controller"
application.register("filter-search", FilterSearchController)

import CashFlowDrilldownController from "./cash_flow_drilldown_controller"
application.register("cash-flow-drilldown", CashFlowDrilldownController)

import CashFlowAutoExpandController from "./cash_flow_auto_expand_controller"
application.register("cash-flow-auto-expand", CashFlowAutoExpandController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import NestedRowsController from "./nested_rows_controller"
application.register("nested-rows", NestedRowsController)

import ProductGridController from "./product_grid_controller"
application.register("product-grid", ProductGridController)

import LookupFillController from "./lookup_fill_controller"
application.register("lookup-fill", LookupFillController)

import AutoRefreshController from "./auto_refresh_controller"
application.register("auto-refresh", AutoRefreshController)
